// @ts-strict-ignore
import { useLocation } from 'react-router-dom';

export const useGetRedirectUrl = () => {
  const { pathname, search } = useLocation();

  const oldSearchParams = new URLSearchParams(search);

  const queryParams = {};
  for (const [key, value] of oldSearchParams.entries()) {
    if (!key.startsWith('overlay-')) {
      queryParams[key] = value;
    }
  }
  const newSearchParams = new URLSearchParams(queryParams);

  return newSearchParams.toString()
    ? `${pathname}?${newSearchParams.toString()}`
    : pathname;
};
